<template>
    <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <proveedor-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import ProveedorProvider from "../../../providers/ProveedorProvider";
    import {CrudUpdate} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    import ProveedorForm from "../ProveedorForm";

    export default {
        name: "ProveedorUpdate",
        components: { ProveedorForm, CrudUpdate },
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'proveedor.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    id: this.item.id,
                    nombre: this.item.nombre,
                    cuit: this.item.cuit || null,
                    email: this.item.email || null,
                    telefono: this.item.telefono || null,
                }
            }
        },
        methods: {
            update() {
                this.$refs.form.validateThenConfirm(() => this.performUpdate())
            },
            performUpdate() {
                this.loading = true
                this.errorMessage = ''
                ProveedorProvider.updateProveedor(this.form)
                    .then(r => {
                        if (r) {
                            this.$emit('itemUpdated', r.data.proveedorUpdate)
                            this.$emit('close')
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.inputErrors = clientError.inputErrors
                        this.errorMessage = clientError.i18nMessage
                    })
                    .finally(() => { this.loading = false })
            }
        },
    }
</script>

<style scoped>

</style>
